import { useFormikContext } from 'formik'

import { useInitData } from '../../../hooks'
import { hasTinyMceHtmlVisibleText } from '../../../utils/html'
import { AITextGenerationType } from '../../AITextGeneration'
import {
  AITextGenerationField,
  applyAITextToWysiwygField,
} from '../../AITextGenerationField'
import { FormFieldsContainer } from '../../Form'
import { NEWSBOARD_POST_MESSAGE_FIELD_NAME } from '../Newsboard.constants'
import { NewsboardMessageField } from '../NewsboardMessageField'

export function NewsboardPostProfileEditMessageModalFields({
  editorRef,
  ticker,
  onInitEditor,
}) {
  const { values } = useFormikContext()

  const { ai_features: aiFeatures } = useInitData()

  function handleApplyAITextToWysiwyg(generatedText, currentValue, action) {
    return applyAITextToWysiwygField({
      action,
      currentValue,
      editorRef,
      generatedText,
    })
  }

  const messageField = (
    <NewsboardMessageField
      autoFocus
      skipFieldWrapper
      name={NEWSBOARD_POST_MESSAGE_FIELD_NAME}
      ticker={ticker}
      onInitEditor={onInitEditor}
    />
  )

  const showAiGeneration = !ticker && aiFeatures?.text_generation

  return (
    <FormFieldsContainer>
      {showAiGeneration ? (
        <AITextGenerationField
          fieldContent={values[NEWSBOARD_POST_MESSAGE_FIELD_NAME]}
          fieldName={NEWSBOARD_POST_MESSAGE_FIELD_NAME}
          hasExistingContent={hasTinyMceHtmlVisibleText(
            values[NEWSBOARD_POST_MESSAGE_FIELD_NAME]
          )}
          type={AITextGenerationType.Post}
          onApplyText={handleApplyAITextToWysiwyg}
        >
          {messageField}
        </AITextGenerationField>
      ) : (
        messageField
      )}
    </FormFieldsContainer>
  )
}
